// Shared utility function for consistent category chip styling across all components

export const getCategoryStyling = (category: string): { bg: string; text: string } => {
  const categoryLower = category.toLowerCase();

  // Current categorization system: NEW, GREEN, AMBER, RED
  if (categoryLower.includes('new')) {
    return { bg: 'bg-purple-100', text: 'text-purple-800' };
  } else if (categoryLower.includes('green')) {
    return { bg: 'bg-green-100', text: 'text-green-800' };
  } else if (categoryLower.includes('amber')) {
    return { bg: 'bg-yellow-100', text: 'text-yellow-800' };
  } else if (categoryLower.includes('red')) {
    return { bg: 'bg-red-100', text: 'text-red-800' };
  } else if (categoryLower.includes('regular') || categoryLower.includes('standard')) {
    return { bg: 'bg-blue-100', text: 'text-blue-800' };
  } else if (categoryLower.includes('premium') || categoryLower.includes('vip')) {
    return { bg: 'bg-purple-100', text: 'text-purple-800' };
  } else if (categoryLower.includes('at-risk') || categoryLower.includes('risk')) {
    return { bg: 'bg-red-100', text: 'text-red-800' };
  } else if (categoryLower.includes('prospect')) {
    return { bg: 'bg-green-100', text: 'text-green-800' };
  } else if (categoryLower.includes('inactive') || categoryLower.includes('dormant')) {
    return { bg: 'bg-gray-100', text: 'text-gray-800' };
  } else {
    return { bg: 'bg-indigo-100', text: 'text-indigo-800' };
  }
};
